
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/context/AuthContext";

export type UserRole = 'admin' | 'moderator' | 'user';

export const useUserRole = () => {
  const { user, loading: authLoading } = useAuth();

  const { data: role, isLoading: roleLoading } = useQuery({
    queryKey: ['userRole', user?.id],
    queryFn: async (): Promise<UserRole | null> => {
      console.log("useUserRole: Fetching role for user:", user?.id);
      
      if (!user) {
        console.log("useUserRole: No user found, returning null role");
        return null;
      }

      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id)
        .maybeSingle();

      if (error) {
        console.error("useUserRole: Error fetching user role:", error);
        throw error;
      }

      console.log("useUserRole: Role fetched:", data?.role);
      const raw = data?.role as string | undefined;
      if (raw === 'admin' || raw === 'moderator') return raw;
      return 'user';
    },
    enabled: !!user && !authLoading,
    staleTime: 30000, // Consider the data fresh for 30 seconds
    retry: 2 // Retry failed requests twice
  });

  const isLoading = authLoading || roleLoading;
  const isAdmin = role === 'admin';

  return {
    role,
    isAdmin,
    isLoading,
  };
};
